import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

const useIsResponsive = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const isTablet = useMediaQuery('(max-width:1080px)')

  return [isMobile, isTablet, isSmallMobile] as const
}

export default useIsResponsive
